/** Русская плюрализация: pluralizeRu(5, 'день', 'дня', 'дней') → 'дней'. */
export function pluralizeRu(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n));
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}

/** «7 дней», «1 день», «3 дня» */
export function formatDays(n: number): string {
  return `${n} ${pluralizeRu(n, 'день', 'дня', 'дней')}`;
}

/** «До 3 устройств» — родительный падеж после «до» */
export function devicesUpTo(n: number): string {
  return `До ${n} ${pluralizeRu(n, 'устройства', 'устройств', 'устройств')}`;
}
